import { contactConstants } from '../constants';

export const contactActions = {
    sendMail: (data) => ({ type: contactConstants.CONTACT_SEND_REQUEST, data }),
    clearState: () => ({ type: contactConstants.CONTACT_CLEAR_STATE }),
};
